export default "immagini/logo-completo-semplice-bianco.svg"